<mat-card>
   <form #loginForm="ngForm">
   <mat-toolbar>
    {{'dedicacions.titol' | translate }} ({{userInfo.nom}})
    <div style="width:100%;float:right">
      <button style="float: right;margin-left: 5px" mat-icon-button (click)="close()" matTooltip="{{('dedicacions.tancar') | translate}}" attr.aria-label="{{('dedicacions.tancar') | translate}}" matTooltipClass="tooltip-style">
         <mat-icon color="primary" style="font-size:24px">close</mat-icon>
      </button>
      <button style="float: right;margin-right: 0" mat-icon-button (click)="desar()" matTooltip="{{ 'dedicacionsMes.desarToolTip' | translate }}" attr.aria-label="{{ 'dedicacionsMes.desarToolTip' | translate }}" matTooltipClass="tooltip-style">
         <mat-icon color="primary" style="font-size:24px">save</mat-icon>
      </button>
    </div>
   </mat-toolbar>
   <mat-progress-bar mode="indeterminate" color="warm" *ngIf="showAsyncProgress" style="position: absolute;"></mat-progress-bar>
   <mat-form-field style="float: left;clear: none;width: 100px;padding-left:20px;padding-top:20px;color:black">
      <input matInput type="text" [(ngModel)]="year" name="year" placeholder="{{ 'dedicacionsMes.anyPlaceholder' | translate }}">
   </mat-form-field>
   <mat-form-field style="float: left;clear: none;width: 200px;padding-top:20px">
     <mat-select [(ngModel)]="tipus" name="tipus" style="width:100%;border: 0px;padding-top:0px" placeholder="{{ 'propostaMi.camps.tipus' | translate }}">
       <mat-option value="Treballs">{{ 'projectsList.titols.treballs' | translate }}</mat-option>
       <mat-option value="Propostes">{{ 'projectsList.titols.propostes' | translate }}</mat-option>
     </mat-select>
   </mat-form-field>
   <button matTooltip="{{'notes.cerca' | translate}}" attr.aria-label="{{'notes.cerca' | translate}}" matTooltipClass="tooltip-style" mat-button (click)="filtrar()" style="min-width:45px;padding-top:25px">
      <mat-icon color="primary" style="font-size: 24px">search</mat-icon>
   </button>
<div class="tb-container mat-elevation-z8">
   <mat-table  #table="matTable" [dataSource]="dataSource" style="height:450px">
    <ng-container matColumnDef="codi">
      <mat-header-cell *matHeaderCellDef> {{ 'propostaMi.camps.codi' | translate }} </mat-header-cell>
      <mat-cell *matCellDef="let element">
         <div title="{{element.titol}}" *ngIf="element.ambit_proposta=='Europa'" style='color:#0000FF;font-size:1em'>{{element.codi | striphtml | slice:0:150}}</div>
         <div title="{{element.titol}}" *ngIf="element.ambit_proposta=='Internacional'" style='color:#008800;font-size:1em'>{{element.codi | striphtml | slice:0:150}}</div>
         <div title="{{element.titol}}" *ngIf="element.ambit_proposta=='Catalunya'" style="color:rgb(100,100,100);font-size:1em">{{element.codi | striphtml | slice:0:150}}</div>
         <div title="{{element.titol}}" *ngIf="element.ambit_proposta=='Espanya'" style="color:#800000;font-size:1em">{{element.codi | striphtml | slice:0:150}}</div>
         <div title="{{ 'dedicacionsMes.totalMesTitle' | translate }}" *ngIf="element.ambit_proposta==''" style="font-size:1em">{{element.codi}}</div>
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="January">
      <mat-header-cell *matHeaderCellDef [ngStyle]="{'font-weight': mesActual == 'January'?'bold':'normal'}"> {{ 'dedicacionsMes.mesos.gen' | translate }} </mat-header-cell>
      <mat-cell *matCellDef="let element; let index = index" [ngStyle]="{'background-color': mesActual == 'January'?'#dee8f4':'white'}"> 
        <mat-form-field style="font-size:0.8em;">
          <input type="text" matInput [(ngModel)]="element.January" name="january-{{index}}">
        </mat-form-field>
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="February">
      <mat-header-cell *matHeaderCellDef [ngStyle]="{'font-weight': mesActual == 'February'?'bold':'normal'}"> {{ 'dedicacionsMes.mesos.feb' | translate }} </mat-header-cell>
      <mat-cell *matCellDef="let element; let index = index" [ngStyle]="{'background-color': mesActual == 'February'?'#dee8f4':'white'}">
        <mat-form-field style="font-size:0.8em;">
          <input type="text" matInput [(ngModel)]="element.February" name="february-{{index}}">
        </mat-form-field>
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="March">
      <mat-header-cell *matHeaderCellDef [ngStyle]="{'font-weight': mesActual == 'March'?'bold':'normal'}"> {{ 'dedicacionsMes.mesos.marc' | translate }} </mat-header-cell>
      <mat-cell *matCellDef="let element; let index = index" [ngStyle]="{'background-color': mesActual == 'March'?'#dee8f4':'white'}">
        <mat-form-field style="font-size:0.8em;">
          <input type="text" matInput [(ngModel)]="element.March" name="march-{{index}}" >
        </mat-form-field>
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="April">
      <mat-header-cell *matHeaderCellDef [ngStyle]="{'font-weight': mesActual == 'April'?'bold':'normal'}"> {{ 'dedicacionsMes.mesos.abr' | translate }} </mat-header-cell>
      <mat-cell *matCellDef="let element; let index = index" [ngStyle]="{'background-color': mesActual == 'April'?'#dee8f4':'white'}">
        <mat-form-field style="font-size:0.8em;">
          <input type="text" matInput [(ngModel)]="element.April" name="april-{{index}}" >
        </mat-form-field>
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="May">
      <mat-header-cell *matHeaderCellDef [ngStyle]="{'font-weight': mesActual == 'May'?'bold':'normal'}"> {{ 'dedicacionsMes.mesos.maig' | translate }} </mat-header-cell>
      <mat-cell *matCellDef="let element; let index = index" [ngStyle]="{'background-color': mesActual == 'May'?'#dee8f4':'white'}">
        <mat-form-field style="font-size:0.8em;">
          <input type="text" matInput [(ngModel)]="element.May" name="may-{{index}}" >
        </mat-form-field>
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="June">
      <mat-header-cell *matHeaderCellDef [ngStyle]="{'font-weight': mesActual == 'June'?'bold':'normal'}"> {{ 'dedicacionsMes.mesos.juny' | translate }} </mat-header-cell>
      <mat-cell *matCellDef="let element; let index = index" [ngStyle]="{'background-color': mesActual == 'June'?'#dee8f4':'white'}">
        <mat-form-field style="font-size:0.8em;">
          <input type="text" matInput [(ngModel)]="element.June" name="june-{{index}}" >
        </mat-form-field>
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="July">
      <mat-header-cell *matHeaderCellDef [ngStyle]="{'font-weight': mesActual == 'July'?'bold':'normal'}"> {{ 'dedicacionsMes.mesos.jul' | translate }} </mat-header-cell>
      <mat-cell *matCellDef="let element; let index = index" [ngStyle]="{'background-color': mesActual == 'July'?'#dee8f4':'white'}">
        <mat-form-field style="font-size:0.8em;">
          <input type="text" matInput [(ngModel)]="element.July" name="july-{{index}}" >
        </mat-form-field>
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="August">
      <mat-header-cell *matHeaderCellDef [ngStyle]="{'font-weight': mesActual == 'August'?'bold':'normal'}"> {{ 'dedicacionsMes.mesos.ag' | translate }} </mat-header-cell>
      <mat-cell *matCellDef="let element; let index = index" [ngStyle]="{'background-color': mesActual == 'August'?'#dee8f4':'white'}">
        <mat-form-field style="font-size:0.8em;">
          <input type="text" matInput [(ngModel)]="element.August" name="august-{{index}}" >
        </mat-form-field>
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="September">
      <mat-header-cell *matHeaderCellDef [ngStyle]="{'font-weight': mesActual == 'September'?'bold':'normal'}"> {{ 'dedicacionsMes.mesos.set' | translate }} </mat-header-cell>
      <mat-cell *matCellDef="let element; let index = index" [ngStyle]="{'background-color': mesActual == 'September'?'#dee8f4':'white'}">
        <mat-form-field style="font-size:0.8em;">
          <input type="text" matInput [(ngModel)]="element.September" name="september-{{index}}" >
        </mat-form-field>
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="October">
      <mat-header-cell *matHeaderCellDef [ngStyle]="{'font-weight': mesActual == 'October'?'bold':'normal'}"> {{ 'dedicacionsMes.mesos.oct' | translate }} </mat-header-cell>
      <mat-cell *matCellDef="let element; let index = index" [ngStyle]="{'background-color': mesActual == 'October'?'#dee8f4':'white'}">
        <mat-form-field style="font-size:0.8em;">
          <input type="text" matInput [(ngModel)]="element.October" name="october-{{index}}" >
        </mat-form-field>
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="November">
      <mat-header-cell *matHeaderCellDef [ngStyle]="{'font-weight': mesActual == 'November'?'bold':'normal'}"> {{ 'dedicacionsMes.mesos.nov' | translate }} </mat-header-cell>
      <mat-cell *matCellDef="let element; let index = index" [ngStyle]="{'background-color': mesActual == 'November'?'#dee8f4':'white'}">
        <mat-form-field style="font-size:0.8em;">
          <input type="text" matInput [(ngModel)]="element.November" name="november-{{index}}" >
        </mat-form-field>
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="December">
      <mat-header-cell *matHeaderCellDef [ngStyle]="{'font-weight': mesActual == 'December'?'bold':'normal'}"> {{ 'dedicacionsMes.mesos.des' | translate }} </mat-header-cell>
      <mat-cell *matCellDef="let element; let index = index" [ngStyle]="{'background-color': mesActual == 'December'?'#dee8f4':'white'}">
        <mat-form-field style="font-size:0.8em;">
          <input type="text" matInput [(ngModel)]="element.December" name="december-{{index}}">
        </mat-form-field>
    </mat-cell>
    </ng-container>
    <ng-container matColumnDef="Total">
      <mat-header-cell *matHeaderCellDef> {{ 'dedicacionsMes.totalCol' | translate }}</mat-header-cell>
      <mat-cell *matCellDef="let element" style="font-size:0.8em;font-weight:bold;margin-left:5px;padding-bottom:7px;"><span style="float:right;text-align:right;width:60%">{{element.Total | number}}</span></mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <div class="table-content-wrapper">
     <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
    </div>
   </mat-table>

   <mat-table #table1="matTable" [dataSource]="dataPropSource" style="height:250px">
    <ng-container matColumnDef="codi">
      <mat-header-cell *matHeaderCellDef [ngStyle]="{'width':'500px'}"> {{ 'propostaMi.camps.codi' | translate }} </mat-header-cell>
      <mat-cell *matCellDef="let element" [ngStyle]="{'width':'500px'}">
         <div title="{{element.titol}}" *ngIf="element.ambit_proposta=='Europa'" style='color:#0000FF;font-size:1em'>{{element.codi | striphtml | slice:0:150}}</div>
         <div title="{{element.titol}}" *ngIf="element.ambit_proposta=='Internacional'" style='color:#008800;font-size:1em'>{{element.codi | striphtml | slice:0:150}}</div>
         <div title="{{element.titol}}" *ngIf="element.ambit_proposta=='Catalunya'" style="color:rgb(100,100,100);font-size:1em">{{element.codi | striphtml | slice:0:150}}</div>
         <div title="{{element.titol}}" *ngIf="element.ambit_proposta=='Espanya'" style="color:#800000;font-size:1em">{{element.codi | striphtml | slice:0:150}}</div>
         <div title="{{ 'dedicacionsMes.totalMesTitle' | translate }}" *ngIf="element.ambit_proposta==''" style="font-size:1em">{{element.codi}}</div>
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="January">
      <mat-header-cell *matHeaderCellDef [ngStyle]="{'font-weight': mesActual == 'January'?'bold':'normal'}"> {{ 'dedicacionsMes.mesos.gen' | translate }} </mat-header-cell>
      <mat-cell *matCellDef="let element; let index = index" [ngStyle]="{'background-color': mesActual == 'January'?'#dee8f4':'white'}"><span style="width: 80%;float: right;text-align: right;font-size:12px">{{element.January}}</span>
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="February">
      <mat-header-cell *matHeaderCellDef [ngStyle]="{'font-weight': mesActual == 'February'?'bold':'normal'}"> {{ 'dedicacionsMes.mesos.feb' | translate }} </mat-header-cell>
      <mat-cell *matCellDef="let element; let index = index" [ngStyle]="{'background-color': mesActual == 'February'?'#dee8f4':'white'}">
        <span style="width: 80%;float: right;text-align: right;font-size:12px">{{element.February}}</span>
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="March">
      <mat-header-cell *matHeaderCellDef [ngStyle]="{'font-weight': mesActual == 'March'?'bold':'normal'}"> {{ 'dedicacionsMes.mesos.marc' | translate }} </mat-header-cell>
      <mat-cell *matCellDef="let element; let index = index" [ngStyle]="{'background-color': mesActual == 'March'?'#dee8f4':'white'}">
        <span style="width: 80%;float: right;text-align: right;font-size:12px">
        {{element.March}}</span>
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="April">
      <mat-header-cell *matHeaderCellDef [ngStyle]="{'font-weight': mesActual == 'April'?'bold':'normal'}"> {{ 'dedicacionsMes.mesos.abr' | translate }} </mat-header-cell>
      <mat-cell *matCellDef="let element; let index = index" [ngStyle]="{'background-color': mesActual == 'April'?'#dee8f4':'white'}">
        <span style="width: 80%;float: right;text-align: right;font-size:12px">{{element.April}}</span>
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="May">
      <mat-header-cell *matHeaderCellDef [ngStyle]="{'font-weight': mesActual == 'May'?'bold':'normal'}"> {{ 'dedicacionsMes.mesos.maig' | translate }} </mat-header-cell>
      <mat-cell *matCellDef="let element; let index = index" [ngStyle]="{'background-color': mesActual == 'May'?'#dee8f4':'white'}">
        <span style="width: 80%;float: right;text-align: right;font-size:12px">{{element.May}}</span>
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="June">
      <mat-header-cell *matHeaderCellDef [ngStyle]="{'font-weight': mesActual == 'June'?'bold':'normal'}"> {{ 'dedicacionsMes.mesos.juny' | translate }} </mat-header-cell>
      <mat-cell *matCellDef="let element; let index = index" [ngStyle]="{'background-color': mesActual == 'June'?'#dee8f4':'white'}">
          <span style="width: 80%;float: right;text-align: right;font-size:12px">{{element.June}}</span>
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="July">
      <mat-header-cell *matHeaderCellDef [ngStyle]="{'font-weight': mesActual == 'July'?'bold':'normal'}"> {{ 'dedicacionsMes.mesos.jul' | translate }} </mat-header-cell>
      <mat-cell *matCellDef="let element; let index = index" [ngStyle]="{'background-color': mesActual == 'July'?'#dee8f4':'white'}">
          <span style="width: 80%;float: right;text-align: right;font-size:12px">{{element.July}}</span>
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="August">
      <mat-header-cell *matHeaderCellDef [ngStyle]="{'font-weight': mesActual == 'August'?'bold':'normal'}"> {{ 'dedicacionsMes.mesos.ag' | translate }} </mat-header-cell>
      <mat-cell *matCellDef="let element; let index = index" [ngStyle]="{'background-color': mesActual == 'August'?'#dee8f4':'white'}">
        <span style="width: 80%;float: right;text-align: right;font-size:12px">{{element.August}}</span>
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="September">
      <mat-header-cell *matHeaderCellDef [ngStyle]="{'font-weight': mesActual == 'September'?'bold':'normal'}"> {{ 'dedicacionsMes.mesos.set' | translate }} </mat-header-cell>
      <mat-cell *matCellDef="let element; let index = index" [ngStyle]="{'background-color': mesActual == 'September'?'#dee8f4':'white'}">
        <span style="width: 80%;float: right;text-align: right;font-size:12px">{{element.September}}</span>
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="October">
      <mat-header-cell *matHeaderCellDef [ngStyle]="{'font-weight': mesActual == 'October'?'bold':'normal'}"> {{ 'dedicacionsMes.mesos.oct' | translate }} </mat-header-cell>
      <mat-cell *matCellDef="let element; let index = index" [ngStyle]="{'background-color': mesActual == 'October'?'#dee8f4':'white'}">
        <span style="width: 80%;float: right;text-align: right;font-size:12px">{{element.October}}</span>
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="November">
      <mat-header-cell *matHeaderCellDef [ngStyle]="{'font-weight': mesActual == 'November'?'bold':'normal'}"> {{ 'dedicacionsMes.mesos.nov' | translate }} </mat-header-cell>
      <mat-cell *matCellDef="let element; let index = index" [ngStyle]="{'background-color': mesActual == 'November'?'#dee8f4':'white'}">
<span style="width: 80%;float: right;text-align: right;font-size:12px">{{element.November}}</span>
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="December">
      <mat-header-cell *matHeaderCellDef [ngStyle]="{'font-weight': mesActual == 'December'?'bold':'normal'}"> {{ 'dedicacionsMes.mesos.des' | translate }} </mat-header-cell>
      <mat-cell *matCellDef="let element; let index = index" [ngStyle]="{'background-color': mesActual == 'December'?'#dee8f4':'white'}">
      <span style="width: 80%;float: right;text-align: right;font-size:12px">{{element.December}}</span>
    </mat-cell>
    </ng-container>
    <ng-container matColumnDef="Total">
      <mat-header-cell *matHeaderCellDef> {{ 'dedicacionsMes.totalCol' | translate }}</mat-header-cell>
      <mat-cell *matCellDef="let element" style="font-size:0.8em;font-weight:bold;margin-left:10px;text-align:right;padding-bottom:5px"><span style="float:right;text-align:right;width:60%">{{element.Total | number}}</span></mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <div class="table-content-wrapper">
     <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
    </div>
   </mat-table>
</div>
 </form>
</mat-card>
